<template>
  <div>
    <!-- <v-parallax dark :src="require('../../assets/1446.jpg')"> -->
    <!-- <a href="https://www.freepik.com/free-photos-vectors/tree">Tree vector created by upklyak - www.freepik.com</a> -->
    <v-parallax :src="require('@/assets/city_2560.jpg')" height="650">
      <v-row align="center" justify="center">
        <v-col class="text-center" cols="12">
          <!-- <h1 class="display-1 font-weight-thin mb-4">Vuetify.js</h1>
          <h4 class="subheading">Build your application today!</h4>-->
          <div class="mt-5">
            <span class="welcome headline">Welcome to</span>
            <span
              class="loggable ml-1 headline font-weight-medium blue--text text--lighten-2"
            >loggable</span>
          </div>

          <p class="mt-4 title font-weight-light blue--text text--darken-4">
            Log your projects the
            <span class="title font-weight-thin font-italic">easy</span> way!
          </p>

          <div>Love your project again</div>

          <v-flex xs12>
            <v-img :src="require('@/assets/document.svg')" class="my-3" contain height="200"></v-img>
          </v-flex>

          <v-btn color="primary" dark @click.stop="login" class="mt-4">Login</v-btn>
        </v-col>
      </v-row>
    </v-parallax>
    <v-container>
      <v-row class="text-center body-2">
        <!-- <v-col>
          <div class="mt-5">
            <span class="welcome headline">Welcome to</span>
            <span
              class="loggable ml-1 headline font-weight-medium blue--text text--lighten-2"
            >loggable</span>
          </div>

          <p class="mt-4 title font-weight-light blue--text text--darken-4">
            Log your projects the
            <span class="title font-weight-thin font-italic">easy</span> way!
          </p>

          <div>Love your project again</div>

          <v-flex xs12>
            <v-img :src="require('@/assets/document.svg')" class="my-3" contain height="200"></v-img>
          </v-flex>

          <v-btn color="primary" dark @click.stop="login" class="mt-4">Login</v-btn>
        </v-col>-->
      </v-row>
      <v-row justify="center">
        <v-dialog v-model="showLoginForm" max-width="350px">
          <DialogLogin :item="obj" />
        </v-dialog>
        <v-dialog v-model="showRegisterForm" max-width="350px">
          <DialogRegister :item="obj" />
        </v-dialog>
      </v-row>
      <!-- <v-divider class="mt-10 mb-10"></v-divider> -->
      <v-row class="mt-10">
        <!-- <v-col cols="12" sm="1" md="2"></v-col> -->

        <v-col cols="12" sm="6" md="6">
          <v-card class="mx-auto text-center" height="185px">
            <v-img src="https://cdn.vuetifyjs.com/images/cards/sunshine.jpg" height="80px"></v-img>
            <v-card-text>
              <div class="headline font-weight-thin">Insight through Dashboards</div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-card class="mx-auto text-center" height="185px">
            <v-img src="https://cdn.vuetifyjs.com/images/cards/mountain.jpg" height="80px"></v-img>
            <v-card-text>
              <div class="headline font-weight-thin">Track all of your project</div>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- <v-col cols="12" sm="1" md="2"></v-col> -->
      </v-row>

      <v-row justify="center" class="mt-10">
        <v-col cols="12" sm="6" md="6">
          <v-card class="mx-auto" flat>
            <v-card-text class="text-center">
              <div class="display-1 font-weight-thin">Insight through Dashboards</div>
            </v-card-text>
            <v-card-text>
              <div
                class="subtitle-1 font-weight-regular"
              >Gain valuable inside you might not have realised before, such as:</div>

              <div class="subtitle-1 font-weight-light">Revenue by area</div>
              <div class="subtitle-1 font-weight-light">Revenue by project type</div>
              <div class="subtitle-1 font-weight-light">Type of project by area</div>
              <div class="subtitle-1 font-weight-light">Margins by project type or area</div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-card class="mx-auto text-center" color="rgb(188, 193, 147)" dark>
            <v-card-title>
              <v-icon class="mr-12" size="64">mdi-heart-pulse</v-icon>
              <!-- <v-row align="start">
              <div class="caption grey--text text-uppercase">Revenue by project type</div>
              <div>
                <span class="display-2 font-weight-black" v-text="avg || '—'"></span>
                <strong v-if="avg">k</strong>
              </div>
              </v-row>-->

              <v-spacer></v-spacer>

              <v-btn icon class="align-self-start" size="28">
                <v-icon>mdi-arrow-right-thick</v-icon>
              </v-btn>
            </v-card-title>
            <v-sheet color="rgb(90, 162, 109)">
              <v-sparkline
                :value="value"
                color="rgba(255, 255, 255, .7)"
                height="100"
                padding="24"
                stroke-linecap="round"
                smooth
                auto-draw
              >
                <template v-slot:label="item">£{{ item.value }}</template>
              </v-sparkline>
            </v-sheet>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="mt-10">
        <v-col cols="12" sm="6" md="6">
          <v-card class="mx-auto text-center" color="rgb(188, 193, 147)" dark>
            <v-img src="https://cdn.vuetifyjs.com/images/cards/mountain.jpg" max-height="300px"></v-img>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-card class="mx-auto" flat>
            <v-card-text class="text-center">
              <div class="display-1 font-weight-thin">Track your project</div>
            </v-card-text>
            <v-card-text>
              <div class="subtitle-1 font-weight-regular">Keep track of all your projects:</div>

              <div class="subtitle-1 font-weight-light"></div>
              <div class="subtitle-1 font-weight-light">Revenue by project type</div>
              <div class="subtitle-1 font-weight-light">Type of project by area</div>
              <div class="subtitle-1 font-weight-light">Margins by project type or area</div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="mt-10">
        <v-col cols="12" sm="6" md="6">
          <v-card class="mx-auto" flat>
            <v-card-text class="text-center">
              <div class="display-1 font-weight-thin">Configure your preferences</div>
            </v-card-text>
            <v-card-text>
              <div class="subtitle-1 font-weight-regular">:</div>

              <div class="subtitle-1 font-weight-light">Customise your project types</div>
              <div class="subtitle-1 font-weight-light">Enter custom state your project can be in</div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-card class="mx-auto text-center" color="rgb(188, 193, 147)" dark>
            <v-img src="https://cdn.vuetifyjs.com/images/cards/mountain.jpg" max-height="300px"></v-img>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { db } from "../auth";
import { storeprops } from "../store/helpers.js";
import DialogLogin from "../components/dialogs/DialogLogin";
import DialogRegister from "../components/dialogs/DialogRegister";
import { signinWithEmailAndPassword, signinWithGoogle } from "../auth";

export default {
  components: {
    DialogLogin,
    DialogRegister
  },
  data: () => ({
    showLoginForm: false,
    showRegisterForm: false,
    obj: null,
    error: "",
    value: [423, 446, 675, 510, 590, 610, 760],
    avg: 91
  }),
  computed: {
    ...storeprops
  },
  methods: {
    login() {
      //this.$router.push({ name: "login" });

      //signinWithGoogle(err => (this.error = err));

      // open the login dialog
      this.showLoginForm = true;
    },
    register() {
      this.showRegisterForm = true;
    },
    gotoRegister() {
      this.$router.push({ name: "register" });
    }
  },
  created() {
    this.obj = new objDataLogin();
    this.obj.closeDialog = () => {
      this.showLoginForm = false;
      this.showRegisterForm = false;
    };
    this.obj.showRegister = () => {
      this.showLoginForm = false;
      this.showRegisterForm = true;
    };
    this.obj.showLogin = () => {
      this.showLoginForm = true;
      this.showRegisterForm = false;
    };
  },
  mounted() {
    //debugger;
    // const { currentUser } = firebase.auth();
    // this.user = currentUser;
  }
};

class objDataLogin {
  loginWithEmailAndPassword = null;
  signinWithFacebook = null;
  signinWithGoogle = null;
  closeDialog = null;
}
</script>

<style lang="scss">
.v-parallax__content {
  color: black !important;
}
.v-parallax .v-parallax__image-container {
  opacity: 0.6 !important;
}
</style>